module.exports = __webpack_public_path__ + "img/43-Rouge Clair.jpg";